import request from '@/tools/request';
import { allAuditOssStatus, auditRecord } from '../../api';
import { MessageBox, Notification } from 'element-ui';
import auditRow from '../../services/audit-row';

// 获得 审核记录列表
export const getList = {
  root: false,
  handler: async ({ state, commit, rootState }, params) => {
    const {
      dataAnalysis: {
        projectDetail: { projectId, type }
      }
    } = rootState;
    const query = {
      ...state.tableSearchQuery,
      ...state.pageQuery,
      projectId,
      type,
      isSelected: state.isAll ? '0' : '1',
      ...params
    };
    try {
      commit('SET_TABLE_LOADING', true);
      const res = await auditRecord.auditOssStatusSonList(query);

      const {
        data: {
          data: { list, total, selectedSize }
        }
      } = res;

      // 在返回数据中 加入 请求时的 一些参数 比如 type 字段，type在任务列表点击查看 详情接口 需要
      let result = list.map(i => {
        return {
          ...i,
          type: type
        };
      });
      commit('SET_TABLE_DATA', result);
      commit('SET_SELECTED_SIZE', selectedSize);
      commit('SET_PAGE_TOTAL', total);

      commit('SET_TABLE_LOADING', false);
    } catch (err) {
      commit('SET_TABLE_LOADING', false);
    }
  }
};
export const selectAll = {
  root: false,
  handler: async ({ state, rootState, dispatch }, params) => {
    const {
      dataAnalysis: {
        projectDetail: { projectId, type }
      }
    } = rootState;
    const {
      data: {
        data: { selectedSize },
        code
      }
    } = await request.post(
      '/rest/cso/saas/taskRecord/auditOssStatusSonList/all',
      {
        ...state.pageQuery,
        ...state.tableSearchQuery,
        isSelected: params.isSelected ? '1' : '0',
        projectId: rootState.route.query.projectId,
        type: rootState.route.query.type,
        id: params.id
      }
    );
    if (selectedSize === 0 && params.isSelected === true) {
      Notification({
        title: '失败',
        message: '暂无可操作数据！',
        type: 'error'
      });
    }
    if (+code === 1) {
      dispatch('getList', {
        isSelected: params.isSelected ? '1' : '0',
        projectId: rootState.route.query.projectId,
        id: params.id
      });
    }
  }
};

// 批量审核 isPass 2:通过 3：不通过
export const batchAudit = {
  root: false,
  handler: ({ state, rootState, dispatch }, params) => {
    const { auditStatus, id } = params;
    const {
      dataAnalysis: {
        projectDetail: { projectId }
      }
    } = rootState;

    const query = {
      projectId,
      auditStatus,
      id
    };

    try {
      // 审核 通过
      if (+auditStatus === 2) {
        MessageBox.confirm(
          `<p>是否确认通过 <span style="color:#027cfa">${state.selectedSize}</span> 条任务记录，请谨慎操作</p>`,
          {
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          allAuditOssStatus(query).then(({ data: { message } }) => {
            Notification({
              message: message,
              type: 'success'
            });
            dispatch('getList', { isSelected: 0, id, projectId });
          });
        });
      }
      // 审核 不通过
      if (+auditStatus === 3) {
        auditRow({
          ajax: allAuditOssStatus,
          params: query,
          auditStatus,
          getList: () => dispatch('getList', { isSelected: 0, id, projectId }),
          auditLength: state.selectedSize
        });
      }
    } catch (err) {
      return;
    }
  }
};
